import {
    ResetPasswordAction,
    ResetPasswordSucceededAction,
    ResetPasswordFailedAction,
    ResetPasswordResetStateAction
} from './types';
import {
    RESET_PASSWORD_LOAD_REQUESTED,
    RESET_PASSWORD_LOAD_SUCCEEDED,
    RESET_PASSWORD_LOAD_FAILED,
    RESET_PASSWORD_RESET_STATE
} from './constants';

export function resetPassword(email: string): ResetPasswordAction {
    return {
        type: RESET_PASSWORD_LOAD_REQUESTED,
        email
    };
}

export function resetPasswordSucceeded(): ResetPasswordSucceededAction {
    return {
        type: RESET_PASSWORD_LOAD_SUCCEEDED
    };
}

export function resetPasswordFailed(error: string): ResetPasswordFailedAction {
    return {
        type: RESET_PASSWORD_LOAD_FAILED,
        error
    };
}

export function resetPasswordResetState(): ResetPasswordResetStateAction {
    return {
        type: RESET_PASSWORD_RESET_STATE
    };
}
